module.exports = __webpack_public_path__ + "img/fairviewRaceCourse_BG.cb54bf6b.jpg";